import React from "react";
import { useTranslations } from "next-intl";

interface ArrowButtonProps {
  className?: string;
}
export function ArrowButton({
  className,
}: ArrowButtonProps): React.JSX.Element {
  const t = useTranslations();
  return (
    <div
      className={`${className || ""} lg:size-14 size-10 ltr:lg:-mr-20 rtl:lg:-ml-20 rtl:mr-auto rtl:lg:mr-0 ltr:ml-auto ltr:lg:ml-0 rounded-full ltr:shadow-[2px_1px_5px_-1.5px_#000000c7] rtl:shadow-[-2px_1px_5px_-1.5px_#000000c7] group-hover:shadow-primary relative flex justify-center items-center`}
    >
      <div className="size-1 rounded-full bg-[#7E7E7E] group-hover:bg-primary" />
      <div className="absolute h-px w-16 ltr:lg:right-6 ltr:right-5 rtl:lg:left-6 rtl:left-5 bg-[#7E7E7E] group-hover:bg-primary" />
      <span className="absolute ltr:lg:right-24 ltr:right-20 rtl:lg:left-24 rtl:left-20 -mt-1 uppercase text-[#7E7E7E] group-hover:text-primary rtl:font-dirooz text-lg">
        {t("suppliers.more")}
      </span>
    </div>
  );
}
